import { render, staticRenderFns } from "./SlideYoutubevideo.vue?vue&type=template&id=3a3d715d&scoped=true&"
import script from "./SlideYoutubevideo.vue?vue&type=script&lang=js&"
export * from "./SlideYoutubevideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3d715d",
  null
  
)

export default component.exports